export default {
  one_time: "Ponctuel",
  title: "Choisissez le plan qui vous convient",
  subtitle:
    "Tous les nouveaux utilisateurs commencent avec un essai de {0} jours — découvrez les fonctionnalités Pro.",
  free: "Gratuit",
  basic: "Basique",
  pro: "Professionnel",
  month: "par mois",
  year: "par an",
  freeSubtitle: "Idéal pour les utilisateurs individuels et les tests",
  basicSubtitle: "Parfait pour les petites et moyennes entreprises",
  proSubtitle: "Parfait pour les grandes entreprises et les équipes professionnelles",
  current: "Plan actuel",
  current_plan: "Plan actuel",
  try: "Essayer gratuitement",
  upgrade: "Passer à la version supérieure maintenant",
  contact: "Nous contacter",
  contact_sales: "Contacter les ventes",
  calcs: "calculs",
  reports: "rapports",
  calls_per_month: "appels/mois",
  keys: "clés",
  calculations: "Calculs d'émissions de carbone",
  f_reports: "Rapports PDF",
  f_factor: "Facteurs d'émission de base",
  f_no_api: "Pas d'accès API",
  f_support: "Support par email/ticket",
  priority_support: "Support technique prioritaire",
  b_reports: "Rapports Excel",
  b_factor: "Facteurs d'émission personnalisés",
  b_custom_logo: "Logo personnalisé",
  b_api_access: "Accès API",
  p_dedicated_support: "Support client dédié",
  p_custom_solutions: "Solutions personnalisées",
  p_training: "Services de formation d'équipe",
  refund: "Si vous n'êtes pas satisfait pendant la période d'essai, vous pouvez",
  refund_btn: "demander un remboursement",
  refund_suffix: ".",
  powered_by: "Les services de paiement sont pris en charge par",
  pay_provider: "paddle",
  paymentLegal: {
    title: "Avis juridiques sur les paiements",
    price_currency:
      "Prix : Les prix sont affichés en EUR et traités de manière sécurisée via Paddle, notre marchand mandataire. Des taxes applicables peuvent s'appliquer en fonction de votre emplacement.",
    vat_tax:
      "TVA : Les clients professionnels sont responsables de toute déclaration fiscale applicable. Nous ne percevons actuellement pas la TVA directement, mais Paddle gère les calculs fiscaux lors du passage à la caisse lorsque cela est requis.",
    payment_method:
      "Les paiements sont traités de manière sécurisée via Paddle, prenant en charge les principales cartes de crédit, PayPal, Apple Pay et les méthodes de paiement spécifiques aux pays. Aucun service de garde n'est fourni.",
    financial_liability:
      "Nous ne fournissons pas de services d'investissement, de trading ou de conseil financier. L'accès est strictement réservé à l'abonnement SaaS.",
    refund_policy: "Politique de remboursement :",
    refund_guarantee:
      "Nous offrons une garantie de remboursement de 14 jours pour tous les premiers achats d'abonnement effectués via Paddle.",
    refund_request:
      "Les demandes de remboursement peuvent être soumises via la section Facturation - Commandes ou en contactant notre équipe d'assistance à tout moment.",
    right_of_withdrawal:
      "En accédant ou en utilisant des fonctionnalités payantes — y compris les calculs d'émissions CBAM, la génération de rapports, l'utilisation de l'API ou les calculs automatisés d'audit — vous reconnaissez et acceptez que votre droit de rétractation soit renoncé conformément aux réglementations de protection des consommateurs de l'UE pour les services numériques entièrement livrés dès l'utilisation.",
    subscription_renewals:
      "Les demandes de remboursement soumises dans les 7 jours suivant le renouvellement sont éligibles à un remboursement. Les demandes de remboursement soumises après 7 jours peuvent qualifier pour un remboursement au prorata basé sur la partie inutilisée de la période de facturation. Les remboursements pour les renouvellements ne sont pas autorisés lorsque des fonctionnalités payantes ont déjà été utilisées pendant le cycle de facturation en cours.",
    buy_what_you_need:
      "Les crédits inutilisés peuvent être remboursés à tout moment intégralement. Les crédits utilisés ne sont pas remboursables.",
    refund_restrictions:
      "Les remboursements ne peuvent être accordés si : Un rapport CBAM a été généré. Des calculs d'émissions ou des calculs pertinents pour l'audit ont été effectués. Tout point de terminaison API payant a été utilisé pendant la période de facturation. Une fraude, une mauvaise utilisation ou un abus du service est suspecté.",
    after_refund_approval:
      "Une fois le remboursement approuvé : L'accès à toutes les fonctionnalités payantes sera révoqué immédiatement. Votre compte sera rétrogradé au plan Gratuit. Tous les futurs renouvellements seront annulés. Le quota du plan gratuit restant sera restauré en fonction de la partie inutilisée de l'allocation gratuite originale, et non réinitialisé à la capacité totale.",
  },
  vat_note:
    "Les prix n'incluent pas la TVA applicable. Les utilisateurs de l'UE sont soumis à la TVA locale.",
  pay_per_use_desc: "Paiement à l'usage, aucun abonnement requis",
  pay_per_use_benefits_title: "Avantages du paiement à l'usage",
  pay_per_use_benefit1: "Aucun abonnement requis",
  pay_per_use_benefit2: "Payez uniquement ce que vous utilisez",
  pay_per_use_benefit3: "Valable à vie",
  buy_credits: "Acheter des crédits",
  most_popular: "Le plus populaire",
  save_with_annual: "Économisez {amount} avec le plan annuel",
  monthly: "Mensuel",
  annually: "Annuel",
  enterprise: "Entreprise",
  enterpriseSubtitle: "Des solutions personnalisées conçues pour les utilisateurs professionnels",
  e_custom_solutions: "Solutions personnalisées",
  start_trial: "Essai de {0} jours disponible lors de l'inscription",
  all_paid_plans_include_free:
    "Tous les plans payants incluent tout ce qui est dans le plan gratuit.",
  fq: {
    title: "FAQ sur la facturation et l'abonnement",
    plans_q: "Quels plans d'abonnement sont disponibles ?",
    plans_a:
      "Nous proposons Gratuit (100 calculs/mois), Essai de 14 jours (500 calculs), Basique (49 €/mois), Pro (99 €/mois) et Paiement à l'usage (1,5 €/calcul). Comparez les détails sur la page de tarification.",
    upgrade_q: "Puis-je mettre à niveau ou rétrograder mon plan ?",
    upgrade_a:
      "Oui, mettez à niveau ou rétrogradez instantanément dans les paramètres du compte. Les modifications s'appliquent immédiatement avec des ajustements au prorata.",
    trial_q: "Comment fonctionne l'essai gratuit ?",
    trial_a:
      "Les nouveaux utilisateurs obtiennent un essai de {0} jours avec toutes les fonctionnalités Pro. Il revient au plan Gratuit ({1} calculs) sauf s'il est mis à niveau.",
    autocharge_q: "Mon abonnement se renouvellera-t-il automatiquement ?",
    autocharge_a:
      "Oui, le renouvellement automatique est activé par défaut. Désactivez-le à tout moment dans les paramètres de facturation.",
    payment_methods_q: "Quels modes de paiement sont pris en charge ?",
    payment_methods_a:
      "Les paiements sont traités de manière sécurisée via notre fournisseur de paiement officiel Paddle, prenant en charge les principales cartes de crédit, PayPal, Apple Pay et les méthodes de paiement régionales. La TVA et les taxes applicables sont automatiquement calculées lors du passage à la caisse par Paddle.",
    invoice_q: "Fournissez-vous des factures avec TVA ?",
    invoice_a:
      "Oui, les factures conformes à la TVA sont disponibles après paiement. Les clients de l'UE doivent avoir un numéro de TVA valide pour bénéficier de l'exonération fiscale.",
    refund_q: "Puis-je demander un remboursement ?",
    refund_a:
      "Les demandes de remboursement peuvent être soumises via la page Abonnement dans les Paramètres du compte. L'éligibilité au remboursement suit notre politique de remboursement de 14 jours.",
    data_security_q: "Comment mes données sont-elles protégées ?",
    data_security_a:
      "Nous respectons le RGPD, en utilisant une transmission chiffrée et un stockage sécurisé. Les données sont privées à votre compte.",
    cancel_q: "Que se passe-t-il si j'annule ?",
    cancel_a:
      "Annulez à tout moment dans les paramètres d'abonnement. L'accès dure jusqu'à la fin du cycle de facturation, puis revient au plan Gratuit.",
  },
};
